{
  " Update payment method in <3>Billing Settings</3>": " Update payment method in <3>Billing Settings</3>",
  "${{price}} / mo": "${{price}} / mo",
  "<0>Contact support </0> to update address": "<0>Contact support </0> to update address",
  "Add an item to your cart to checkout": "Add an item to your cart to checkout",
  "Add payment method in <2>Billing Settings</2>": "Add payment method in <2>Billing Settings</2>",
  "Add to Cart": "Add to Cart",
  "Additional charges will be applied for shipping & handling fees": "Additional charges will be applied for shipping & handling fees",
  "Amount will be added to your invoice": "Amount will be added to your invoice",
  "Checkout": "Checkout",
  "Confirm Shipping": "Confirm Shipping",
  "Confirmation and tracking will be sent to this {{email}}": "Confirmation and tracking will be sent to this {{email}}",
  "Contact Support": "Contact Support",
  "Continue Shopping": "Continue Shopping",
  "Decrease quantity": "Decrease quantity",
  "Done": "Done",
  "Features:": "Features:",
  "In Cart": "In Cart",
  "Increase quantity": "Increase quantity",
  "Loading devices...": "Loading devices...",
  "Max quantity of {{count}} devices_one": "Max quantity of {{count}} devices",
  "Max quantity of {{count}} devices_other": "Max quantity of {{count}} devices",
  "No devices available for purchase at this time.": "No devices available for purchase at this time.",
  "Only super admins can purchase devices": "Only super admins can purchase devices",
  "Only super admins can purchase devices. Please contact your admin for assistance.": "Only super admins can purchase devices. Please contact your admin for assistance.",
  "Order placed successfully!": "Order placed successfully!",
  "Paying with {{cardType}} ending in {{cardNumberHash}}.": "Paying with {{cardType}} ending in {{cardNumberHash}}.",
  "Payment Method": "Payment Method",
  "Purchase Desk Phone": "Purchase Desk Phone",
  "Purchase Devices": "Purchase Devices",
  "Purchase Payments Terminal": "Purchase Payments Terminal",
  "Purchase a Device": "Purchase a Device",
  "Purchase device": "Purchase device",
  "Qty:": "Qty:",
  "Remove": "Remove",
  "Retry": "Retry",
  "Return to Checkout": "Return to Checkout",
  "Shipping to": "Shipping to",
  "Something went wrong": "Something went wrong",
  "Something went wrong while loading devices.": "Something went wrong while loading devices.",
  "Subtotal": "Subtotal",
  "Summary": "Summary",
  "View details": "View details",
  "We're sorry for the inconvenience. Please return to checkout and try again.": "We're sorry for the inconvenience. Please return to checkout and try again.",
  "Your Cart ({{count}})_one": "Your Cart ({{count}})",
  "Your Cart ({{count}})_other": "Your Cart ({{count}})",
  "Your order has been placed!": "Your order has been placed!",
  "in cart": "in cart"
}
